import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import BrowserPersistence from "@overrides_venia/peregrine/util/simplePersistence";
import { removeCart } from "../cart";
import { setMemberAttributeFilters } from "../catalog";
import { reset } from "../bookTable";
import { clearCheckoutDataFromStorage } from "../checkout";
import actions from "./actions";
import { parseJwt } from "@Src_main/utils/generalUtils";
var storage = new BrowserPersistence();
var domainMapping = {
  "@biohorta.com": ["BOC", "INTERNAL"],
  "@studbocconi.it": ["BOC"]
};
function removeTypename(obj) {
  if (Array.isArray(obj)) {
    return obj.map(removeTypename);
  } else if (typeof obj === 'object' && obj !== null) {
    var newObj = {};
    for (var [key, value] of Object.entries(obj)) {
      if (key !== '__typename') {
        newObj[key] = removeTypename(value);
      }
    }
    return newObj;
  } else {
    return obj;
  }
}
export var signOut = function () {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _thunk = _asyncToGenerator(function* (dispatch) {
      var {
        revokeToken
      } = payload;
      if (revokeToken) {
        // Send mutation to revoke token.
        try {
          yield revokeToken();
        } catch (error) {
          console.error("Error Revoking Token", error);
        }
      }

      // Remove token from local storage and Redux.
      yield dispatch(clearToken());
      yield dispatch(actions.reset());
      yield clearCheckoutDataFromStorage();
      yield dispatch(reset());
      // Now that we're signed out, forget the old (customer) cart.
      // We don't need to create a new cart here because we're going to refresh
      // the page immediately after.
      dispatch(setMemberAttributeFilters([]));
      yield dispatch(removeCart());
    });
    function thunk(_x) {
      return _thunk.apply(this, arguments);
    }
    return thunk;
  }();
};
export var getUserDetails = _ref => {
  var {
    fetchUserDetails
  } = _ref;
  return /*#__PURE__*/function () {
    var _thunk2 = _asyncToGenerator(function* () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var [dispatch, getState] = args;
      var {
        user
      } = getState();
      if (user.isSignedIn) {
        dispatch(actions.getDetails.request());
        try {
          var {
            data
          } = yield fetchUserDetails({
            fetchPolicy: "network-only"
          });
          var email = data.customer.email;
          var domain = email.substring(email.lastIndexOf("@"));
          var memberAttributes = domainMapping[domain] || [];
          var addressesCleaned = data.customer.addresses.map(removeTypename);
          var customerEnriched = _objectSpread(_objectSpread({}, data.customer), {}, {
            memberAttributes,
            addresses: addressesCleaned
          });
          dispatch(actions.getDetails.receive(customerEnriched));
          dispatch(setMemberAttributeFilters(memberAttributes));
        } catch (error) {
          if (error.message === "The current customer isn't authorized.") {
            yield dispatch(clearToken());
          }
          dispatch(actions.getDetails.receive(error));
        }
      }
    });
    function thunk() {
      return _thunk2.apply(this, arguments);
    }
    return thunk;
  }();
};
export var resetPassword = _ref2 => {
  var {
    email
  } = _ref2;
  return /*#__PURE__*/function () {
    var _thunk3 = _asyncToGenerator(function* () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var [dispatch] = args;
      dispatch(actions.resetPassword.request());

      // TODO: actually make the call to the API.
      // For now, just return a resolved promise.
      yield Promise.resolve(email);
      dispatch(actions.resetPassword.receive());
    });
    function thunk() {
      return _thunk3.apply(this, arguments);
    }
    return thunk;
  }();
};
export var setToken = token => ( /*#__PURE__*/function () {
  var _thunk4 = _asyncToGenerator(function* () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    var [dispatch] = args;
    // Store token in local storage.
    // TODO: Get correct token expire time from API
    var jwtDecoded = parseJwt(token);
    var ttlToken = Math.floor((jwtDecoded.exp * 1000 - Date.now()) / 1000);
    storage.setItem("signin_token", token, ttlToken);

    // Persist in store
    dispatch(actions.setToken(token));
  });
  function thunk() {
    return _thunk4.apply(this, arguments);
  }
  return thunk;
}());
export var setGuestCartId = cartId => ( /*#__PURE__*/function () {
  var _thunk5 = _asyncToGenerator(function* () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    var [dispatch] = args;
    dispatch(actions.setGuestCartId(cartId));
  });
  function thunk() {
    return _thunk5.apply(this, arguments);
  }
  return thunk;
}());
export var clearToken = () => ( /*#__PURE__*/function () {
  var _thunk6 = _asyncToGenerator(function* () {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    var [dispatch] = args;

    // Clear token from local storage
    storage.removeItem("signin_token");

    // Remove from store
    dispatch(actions.clearToken());
  });
  function thunk() {
    return _thunk6.apply(this, arguments);
  }
  return thunk;
}());
export var submitIsSigningIn = payload => ( /*#__PURE__*/function () {
  var _thunk7 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.isSigningIn.submit(payload));
  });
  function thunk(_x2) {
    return _thunk7.apply(this, arguments);
  }
  return thunk;
}());